export const CLIENT_LIST = 'CLIENT_LIST';
export const CLIENT_CREATE = 'CLIENT_CREATE';
export const CLIENT_READ = 'CLIENT_READ';
export const CLIENT_RESET = 'CLIENT_RESET';
export const CLIENT_UPDATE = 'CLIENT_UPDATE';
export const CLIENT_DELETE = 'CLIENT_DELETE';

export const CLIENT_WINE_LIST = 'CLIENT_WINE_LIST';
export const CLIENT_WINE_SET = 'CLIENT_WINE_SET';
export const CLIENT_WINE_UNSET = 'CLIENT_WINE_UNSET';
export const CLIENT_WINE_UPDATE = 'CLIENT_WINE_UPDATE';
